import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from '../../constants/defaultValues';
import { NotificationManager } from '../../components/common/react-notifications';
import {
    REPORT_BUGS_USER_LIST,
    REPORT_BUGS_MENU,
    REPORT_BUGS_RESOURCE,
    REPORT_BUGS_BY_USER,
    REPORT_BUGS_ADD,
    REPORT_BUGS_CANCEL,
    REPORT_BUGS_APPROVED,
    REPORT_BUGS_LIST
} from '../actions';

import {
    ReportBugsUserListSuccess,
    ReportBugsUserListError,
    ReportBugsMenuSuccess,
    ReportBugsMenuError,
    ReportBugsResourceSuccess,
    ReportBugsResourceError,
    ReportBugsByUserSuccess,
    ReportBugsByUserError,
    ReportBugsAddSuccess,
    ReportBugsAddError,
    ReportBugsCancelSuccess,
    ReportBugsCancelError,
    ReportBugsApprovedSuccess,
    ReportBugsApprovedError,
    ReportBugsListSuccess,
    ReportBugsListError,

} from '../actions';

export function* watchReportBugsUserList() {
    yield takeEvery(REPORT_BUGS_USER_LIST, onReportBugsUserList);
}

export function* watchReportBugsMenu() {
    yield takeEvery(REPORT_BUGS_MENU, onReportBugsMenu);
}

export function* watchReportBugsResource() {
    yield takeEvery(REPORT_BUGS_RESOURCE, onReportBugsResource);
}

export function* watchReportBugsByUser() {
    yield takeEvery(REPORT_BUGS_BY_USER, onReportBugsByUser);
}

export function* watchReportBugsAdd() {
    yield takeEvery(REPORT_BUGS_ADD, onReportBugsAdd); 
}

export function* watchReportBugsCancel() {
    yield takeEvery(REPORT_BUGS_CANCEL, onReportBugsCancel); 
}

export function* watchReportBugsApproved() {
    yield takeEvery(REPORT_BUGS_APPROVED, onReportBugsApproved); 
}

export function* watchReportBugsList() {
    yield takeEvery(REPORT_BUGS_LIST, onReportBugsList);
}


function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}

const onReportBugsUserListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'reportBugs/userlist', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onReportBugsMenuAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'reportBugs/menu', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onReportBugsResourceAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'reportBugs/resource', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onReportBugsByUserAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'reportBugs/reportbugslist', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};


const onReportBugsAddAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'reportBugs/add', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onReportBugsCancelAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'reportBugs/cancel', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onReportBugsApprovedAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'reportBugs/approved', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onReportBugsListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'reportBugs/listreportbugs', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

function* onReportBugsUserList(data) {
    try {
        const response = yield call(onReportBugsUserListAsync, data.payload);
        yield put(ReportBugsUserListSuccess(response.data));
    } catch (error) {
        yield put(ReportBugsUserListError(error));
    }
}

function* onReportBugsMenu(data) {
    try {
        const response = yield call(onReportBugsMenuAsync, data.payload);
        yield put(ReportBugsMenuSuccess(response.data));
    } catch (error) {
        yield put(ReportBugsMenuError(error));
    }
}

function* onReportBugsResource(data) {
    try {
        const response = yield call(onReportBugsResourceAsync, data.payload);
        yield put(ReportBugsResourceSuccess(response.data));
    } catch (error) {
        yield put(ReportBugsResourceError(error));
    }
}

function* onReportBugsByUser(data) {
    try {
        const response = yield call(onReportBugsByUserAsync, data.payload);
        yield put(ReportBugsByUserSuccess(response.data));
    } catch (error) {
        yield put(ReportBugsByUserError(error));
    }
}

function* onReportBugsAdd(data) {
    try {
        const response = yield call(onReportBugsAddAsync, data);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }
        yield put(ReportBugsAddSuccess(response.data));
    } catch (error) {
        yield put(ReportBugsAddError(error));
        NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
}

function* onReportBugsCancel(data) {
    try {
        const response = yield call(onReportBugsCancelAsync, data);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }
        yield put(ReportBugsCancelSuccess(response.data));
    } catch (error) {
        yield put(ReportBugsCancelError(error));
        NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
}

function* onReportBugsApproved(data) {
    try {
        const response = yield call(onReportBugsApprovedAsync, data);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }
        yield put(ReportBugsApprovedSuccess(response.data));
    } catch (error) {
        yield put(ReportBugsApprovedError(error));
        NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
}

function* onReportBugsList(data) {
    try {
        const response = yield call(onReportBugsListAsync, data.payload);
        yield put(ReportBugsListSuccess(response.data));
    } catch (error) {
        yield put(ReportBugsListError(error));
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchReportBugsUserList),
        fork(watchReportBugsMenu),
        fork(watchReportBugsResource),
        fork(watchReportBugsByUser),
        fork(watchReportBugsAdd),
        fork(watchReportBugsCancel),
        fork(watchReportBugsApproved),
        fork(watchReportBugsList)
    ]);
}